import script from "./processedFilesDisplayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./processedFilesDisplayer.vue?vue&type=script&setup=true&lang=ts"

import "./processedFilesDisplayer.vue?vue&type=style&index=0&id=1123c808&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1123c808"]])

export default __exports__